mutation ApprovalUpdate($input: ApprovalUpdateInput!) {
  approvalUpdate(input: $input) {
    approval {
      id
      _rowTimestamp
      approvalType {
        id
        approvalType
        layoutType
      }
      id
      approvalTypeId
      isAddApproversEligible
      isPrimary
      isNewApprovalSelectable
      isDelayedApproverAllowed
      statusType {
        statusType
        approvalState
        _transactionIconStatus
      }
      name
      priorityNumber
      description
      approvalTrees {
        nodes {
          id
          _rowTimestamp
          approvalLevel
          _isUpdatable
          _isDeletable
          name
          description
          requiredBranchApprovalCount
          isApprovedByConsensus
          isSingleDeclineConsensusInvoked
          isRejectOnUnderApprovalCount
          isUsedForAdditionalDepartments
          approvalBranches {
            nodes {
              id
              _rowTimestamp
              branchOrder
              description
              _isUpdatable
              _isDeletable
              userOccupation {
                id
                userOccupationTitle
              }
              userRank {
                id
                userRank
              }
              budgetLimitAmount
              budgetLimitPercent
              isOverBudgetSelector
              isBusinessUnitSelector
              isUserGroupSelector
              isWorkgroupSelector
              requesterUserId
              isProjectSelector
              isDepartmentSelector
              transactionStartAmountTotal
              transactionEndAmountTotal
              transactionAmountConversionTypeId
              approverTransactionTypeId
              transactionBusinessUnitId
              transactionDepartmentId
              transactionDepartmentGroupId
              isTransactionNotCondition
              approverDelayDays
              approverDelayHours
              approverDelayStatusTypeId
            }
          }
        }
      }
      approvalSelectionConditions {
        nodes {
          id
          approvalId
          importanceLevel
          description
          startAmountTotal
          endAmountTotal
          _isUpdatable
          _isDeletable
          _rowTimestamp
          requesterCurrencyId
          amountConversionTypeId
          requesterUserOccupationTitleId
          requesterDepartmentId
          requesterDepartmentTypeId
          requesterDepartmentGroupId
          requesterSecureRowLevelId
          startElapsedDays
          endElapsedDays
          requesterTagId
          isAndCondition
          requesterUserRankId
          requesterCompanyId
          requesterBusinessUnitId
          requesterUserId
          requesterPurchaseOrderTypeId
          isAutoApprovedEligible
          approval {
            statusType {
              statusType
            }
          }
        }
        totalCount
      }
    }
  }
}
